import axios from 'axios'
import cdJwt from '../../auth/cd-jwt'
import { Message } from 'element-ui'
const resolveHeader = function (header) {
    if (header == null || header == undefined) return Promise.reject('there is no header')
    return Promise.resolve({ header: { Authorization: header }, token: cdJwt(header) })
}

export default {
    actions: {
        reset(ctx, params) {
            if (params) {
                return Promise.all([
                    Promise.resolve(ctx.commit('setMenu', [])),
                    Promise.resolve(ctx.commit('setApps', [])),
                    Promise.resolve(ctx.commit('setInfo', {})),
                    Promise.resolve(ctx.commit('setAppLoaded', false))
                ]).then(() => Promise.resolve())
            }
        },
        init(ctx) {
            if (ctx.state.isAppLoaded) return Promise.resolve(true)
            const headers = localStorage.getItem('token')
            resolveHeader(headers)
                .then(({ header, token })=>
                    Promise.all(
                        [
                            axios({ url: '/api/globalmenu/usermenu', method: 'get', header })
                                .then(response => Promise.resolve(['menu', response.data.Data]))
                                .catch(reason => Promise.reject(reason)),
                            axios({ url: '/api/global/applications', method: 'get', header })
                                .then(response => Promise.resolve(['apps', response.data.Data]))
                                .catch(reason => Promise.reject(reason)),
                        ]
                    ).then(results => Object.fromEntries(results))
                        .then(results => {
                        ctx.commit('setMenu', results.menu)
                        ctx.commit('setApps', results.apps)
                        ctx.commit('setInfo', token)
                    }).then(() => {
                        if (ctx.getters.currentapp.Disabled) {
                            Message({ type: 'error', message: ctx.getters.currentapp.Reason })
                        }
                        ctx.commit('setAppLoaded', true)
                    }))
                .catch(reason => Promise.reject(reason))
        }
    },
    mutations: {
        setMenu(state, menu) {
            state.myMenu = menu
        },
        setApps(state, apps) {
            state.myApps = apps
        },
        setInfo(state, info) {
            state.myInfo = info
        },
        setAppLoaded(state, value) {
            state.isAppLoaded = value
        }
    },
    state: {
        myMenu: [],
        myApps: [],
        myInfo: {},
        isAppLoaded: false 
    },
    getters: {
        menu(state) {
            return state.myMenu
        },
        apps (state) {
            return state.myApps
        },
        info (state) {
            return state.myInfo
        },
        currentapp (state) {
            return state.myApps.find(a => state.myInfo.ApplicationID == a.ApplicationID)
        },
        isAppReady (state) {
            return state.isAppLoaded
        },
        isMenuDisabled (state, getters) {
            return getters.currentapp == undefined || getters.currentapp.Disabled == true
        }
    },
}